"use client";

import React, { useEffect } from "react";
import { usePathname } from "next/navigation";

export default function GAListener({ children }: { children: React.ReactNode }) {
  const path = usePathname();

  useEffect(() => {
    if (typeof window !== "undefined") {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-call
      window.ga?.("send", "pageview", path);
    }
  }, [path]);

  return <>{children}</>;
}
